/**
 * לקוח ה-API להעלאת מדיה — TASKS 3.4.
 */
import type { AdminApiError } from './adminApi.js';

export interface MediaItem {
  id: number;
  product_id: number;
  variant_id: number | null;
  type: 'image' | 'video';
  url: string;
  poster_url: string | null;
  alt_text: string | null;
  is_primary: number;
  sort_order: number;
  width: number | null;
  height: number | null;
}

async function parseErrorBody(res: Response): Promise<AdminApiError> {
  try {
    const body = (await res.json()) as { error?: { code?: string; message?: string } };
    return {
      status: res.status,
      code: body.error?.code ?? 'UNKNOWN_ERROR',
      message: body.error?.message ?? 'אירעה שגיאה לא צפויה.',
    };
  } catch {
    return { status: res.status, code: 'UNKNOWN_ERROR', message: 'אירעה שגיאה לא צפויה.' };
  }
}

export async function listMedia(productId: number): Promise<MediaItem[]> {
  const res = await fetch(`/api/admin/products/${productId}/media`, { credentials: 'same-origin' });
  if (!res.ok) throw await parseErrorBody(res);
  const body = (await res.json()) as { media: MediaItem[] };
  return body.media;
}

export interface UploadMediaInput {
  file: File;
  posterFile?: File;
  alt: string;
  variantId?: number;
  isPrimary?: boolean;
}

export async function uploadMedia(
  productId: number,
  input: UploadMediaInput,
): Promise<{ id: number }> {
  const form = new FormData();
  form.set('alt', input.alt);
  if (input.variantId !== undefined) form.set('variantId', String(input.variantId));
  if (input.isPrimary) form.set('isPrimary', 'true');
  form.set('file', input.file);
  if (input.posterFile) form.set('posterFile', input.posterFile);

  const res = await fetch(`/api/admin/products/${productId}/media`, {
    method: 'POST',
    credentials: 'same-origin',
    body: form,
  });
  if (!res.ok) throw await parseErrorBody(res);
  return (await res.json()) as { id: number };
}

export async function updateMedia(
  productId: number,
  mediaId: number,
  input: { alt?: string; isPrimary?: boolean },
): Promise<void> {
  const res = await fetch(`/api/admin/products/${productId}/media/${mediaId}`, {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  if (!res.ok) throw await parseErrorBody(res);
}

export async function deleteMedia(productId: number, mediaId: number): Promise<void> {
  const res = await fetch(`/api/admin/products/${productId}/media/${mediaId}`, {
    method: 'DELETE',
    credentials: 'same-origin',
  });
  if (!res.ok) throw await parseErrorBody(res);
}
